module.exports = __webpack_public_path__ + "media/src/Components/ReceiptForm/PDFComponent/fonts/Raleway-3b5635ac5d39c28200bf3993d90d09c7.ttf";